import { render, staticRenderFns } from "./ManageStaff.html?vue&type=template&id=38b32da2&scoped=true&"
import script from "./ManageStaff.vue?vue&type=script&lang=js&"
export * from "./ManageStaff.vue?vue&type=script&lang=js&"
import style0 from "./ManageStaff.scss?vue&type=style&index=0&id=38b32da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b32da2",
  null
  
)

export default component.exports